var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 6.875a3.938 3.938 0 0 0-3.938 3.938 3.921 3.921 0 0 0 3.938 3.937c2.16 0 3.937-1.75 3.937-3.938 0-2.16-1.777-3.937-3.938-3.937zm1.312 4.375h-1.504a.245.245 0 0 1-.246-.246V9.063a.45.45 0 0 1 .438-.438.47.47 0 0 1 .437.438v1.312h.875a.47.47 0 0 1 .438.438.45.45 0 0 1-.438.437zm-5.36 2.188H1.75A.432.432 0 0 1 1.312 13V6H12.25V4.25c0-.957-.793-1.75-1.75-1.75H9.406V1.406c0-.355-.3-.656-.656-.656-.328 0-.656.3-.656.656V2.5H4.156V1.406c0-.355-.3-.656-.656-.656-.383 0-.656.3-.656.656V2.5H1.75C.766 2.5 0 3.293 0 4.25V13c0 .984.766 1.75 1.75 1.75h7.3a4.206 4.206 0 0 1-1.284-1.313z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClock);
export default __webpack_public_path__ + "static/media/calendar-clock.a8fde3c648ccf41068c1252ab910c5ed.svg";
export { ForwardRef as ReactComponent };